import React from 'react';
import { BillboardAdWrapper } from './BillboardAd.style';
import { useSelector } from 'react-redux';
import { isDesktop } from '../../store/common/selector';
import BillboardAdSlot, {
  BillboardAdHeight,
} from '../global/adSlot/BillboardAdSlot';
import MedrecAdSlot, {
  MedrecAdSlotHeight,
} from '../global/adSlot/MedrecAdSlot';
import { useAdTargetingArguments } from './useAdTargetingArguments';

interface BillboardAdProps {
  adUnit: string;
  sect: string;
  subsect?: string;
}

const BillboardAd: React.FC<BillboardAdProps> = ({ adUnit, sect, subsect }) => {
  const targetingArguments = useAdTargetingArguments(sect, subsect);
  const isDesktopDevice = useSelector(isDesktop);

  return (
    <BillboardAdWrapper
      adHeight={isDesktopDevice ? BillboardAdHeight : MedrecAdSlotHeight}
      data-test="billboard-ad"
    >
      {isDesktopDevice ? (
        <BillboardAdSlot
          adUnit={adUnit}
          targetingArguments={targetingArguments}
        />
      ) : (
        <MedrecAdSlot adUnit={adUnit} targetingArguments={targetingArguments} />
      )}
    </BillboardAdWrapper>
  );
};

export default BillboardAd;
